import api from 'api'
import {
  CACHE_TAG_ACCOUNTS_VERSION_LIST,
  CACHE_TAG_ACCOUNT_DETAILS_BY_ID,
  CACHE_TAG_ACCOUNT_EXPANDABLE_VIEW,
  CACHE_TAG_CONFIGURED_SERVICES_LIST,
  CACHE_TAG_CONFIGURED_SERVICE_DETAILS,
  CACHE_TAG_WORK_ORDER_LIST,
} from 'api/cacheTagTypes'

import type { ReactivateAccountApi, ReactivateAccountBody } from 'types/api/account/accountReactivation'

type ReactivateAccountArgs = ReactivateAccountBody & { accountId: string }

const extendedApi = api.injectEndpoints({
  endpoints: build => ({
    reactivateAccountWithCapture: build.mutation<ReactivateAccountApi, ReactivateAccountArgs>({
      query: ({ accountId, ...body }) => ({
        url: `/api/v1/core/accounts/${accountId}/lifecycle/reactivate`,
        method: 'POST',
        body,
      }),
      // A refused request changed nothing, so the dialog's lists have nothing to refetch.
      invalidatesTags: (result, error, { accountId }) =>
        error
          ? []
          : [
              { type: CACHE_TAG_ACCOUNTS_VERSION_LIST, id: accountId },
              { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
              CACHE_TAG_ACCOUNT_EXPANDABLE_VIEW,
              CACHE_TAG_CONFIGURED_SERVICES_LIST,
              // The services are restored by the request itself; only their stops arrive later.
              CACHE_TAG_CONFIGURED_SERVICE_DETAILS,
              CACHE_TAG_WORK_ORDER_LIST,
            ],
    }),
  }),
})

export const { useReactivateAccountWithCaptureMutation } = extendedApi
